import './recently-viewed.scss';
